export default class CommentModalController {
    constructor($uibModalInstance, $scope) {
        this.$uibModalInstance = $uibModalInstance;
        this.$scope = $scope;

        this.boot();
    }

    boot() {
        this.items = this.$scope.params.items;

        this.$uibModalInstance.rendered.then(() => {
            this.initJQuery();
        });
    }

    initJQuery(){

    }

    confirmSelection() {
        this.$uibModalInstance.close(this.items);
    };
}